// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AOY4","title":"Header_title__1pEBg","side":"Header_side__3envE"};